import appStore from 'store';
import api from './api';
import { POSITION_TYPE, PLATFORM_TYPE } from './constants';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    query: {
      language: Number(Object.keys(LANGUAGE)[0]),
      platform: Number(Object.keys(PLATFORM_TYPE)[0]),
      category: 'banner'
    },
    bannerTypes: [],
    bannerList: [],
    detailDialogVisible: false,
    bannerDetail: {},
    positionTypeList: Object.keys(POSITION_TYPE).map(item => {
      return {
        value: Number(item),
        label: POSITION_TYPE[item]
      };
    }),
    platformTypeList: Object.keys(PLATFORM_TYPE).map(item => {
      return {
        value: Number(item),
        label: PLATFORM_TYPE[item]
      };
    }),
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: Number(item),
        label: LANGUAGE[item]
      };
    })
  },
  getters: {
    bannerList: state =>
      state.bannerList
        .map(item => {
          return {
            ...item,
            __positionType: POSITION_TYPE[item.type],
            __language: LANGUAGE[item.language],
            __platform: PLATFORM_TYPE[item.platform]
          };
        })
        .sort((a, b) => a.orderNo - b.orderNo)
        .sort((a, b) => a.platform - b.platform),
    bannerDetail: state => state.bannerDetail
  },
  mutations: {
    setBannerList(state, payload) {
      state.bannerList = payload.slice();
    },
    setBannerTypes(state, payload) {
      state.bannerTypes = payload.slice();
    },
    toggleDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    },
    setBannerDetail(state, payload) {
      state.bannerDetail = Object.assign({}, payload);
    },
    changeQuery(state, payload) {
      state.query = payload;
    }
  },
  actions: {
    list({ commit }, query) {
      api.getBannerList(query).then(({ data }) => {
        commit('setBannerList', data);
      });
    },
    detail({ commit }, id) {
      api.getBannerDetail(id).then(({ data }) => {
        commit('setBannerDetail', data);
      });
    },
    create({ commit }, banner) {
      return new Promise(resolve => {
        api.createBanner(banner).then(res => {
          resolve(res);
        });
      });
    },
    update({ commit }, { createTime, ...banner }) {
      return new Promise(resolve => {
        api.updateBanner(banner).then(res => {
          resolve(res);
        });
      });
    },
    remove({ commit }, id) {
      return new Promise(resolve => {
        api.removeBanner(id).then(res => {
          resolve(res);
        });
      });
    },
    updateSort(context, data) {
      return api.updateSort(data);
    },
    getbannerType({ commit }, query) {
      api.getbannerType(query).then(({ data }) => {
        commit('setBannerTypes', data);
      });
    }
  }
};

appStore.registerModule('appFunctionalPageSetting', store);
